/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.OMS {
    import fld = HSNTaxDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class HSNTaxDetailsEditor extends Common.GridEditorBase<HSNTaxDetailsRow> {
        protected getColumnsKey() { return "OMS.HSNTaxDetails"; }
        protected getDialogType() { return HSNTaxDetailsDialog; }
        protected getLocalTextPrefix() { return HSNTaxDetailsRow.localTextPrefix; }
        exchangerate: number;
        rateid: string;
        public companyid: number;

        private pendingChanges: Q.Dictionary<any> = {};
        private rowSelection = new Serenity.GridRowSelectionMixin(this);

        constructor(container: JQuery) {
            super(container);
            var x = 0;

        }
        public getColumns() {

            var columns = super.getColumns();

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var id = this.id(item);
            var target = $(e.target);

            if (target.hasClass('check-box no-float readonly') || target.hasClass('check-box no-float readonly checked'))
                target.removeClass('readonly')

            if (target.hasClass('check-box no-float')) {
                if (item.IsInterState == true) {
                    item.IsInterState = false;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                }
                else {
                    item.IsInterState = true;
                    this.view.updateItem(id, item);
                    this.view.refresh();

                }
            }

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        this.view.deleteItem(id);
                        this.view.refresh();
                    });
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.ProductSelectGrid;
            buttons.pop();
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Tax",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    OMS.TaxSelectGrid.applicableon = "Product";
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: OMS.TaxSelectGrid, multiple: true, title: "Select Tax",
                        preSelectedKeys: this.value.map(k => k.TaxId)
                    });


                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.TaxId == t.TaxId) });
                        var self = this;
                        var details = [];

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (Tax: OMS.TaxRow) {
                            //var Tax = OMS.TaxRow.getLookup().itemById[value.TaxId];

                            var item: HSNTaxDetailsRow = {
                                TaxName: Tax.TaxName,
                                TaxId: Tax.TaxId,
                                TaxRate: Tax.Rate,
                                IsInterState: false,
                                GroupId: Tax.GroupId

                            };

                            details.push(item);

                        });


                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Detail;
                            if (this.validateEntity(Detail, Detail.DetailsId)) {
                                this.view.addItem(Detail);
                            }
                        }

                        // #endregion

                        // #endregion
                    }


                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.TaxId === row.TaxId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Tax already exists!');
                return false;
            }
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }



    }
}